module.exports = __webpack_public_path__ + "static/media/s4.709dc2e2.jpg";